function expandTargetHidden(target: HTMLElement, trigger: HTMLElement, content: HTMLElement) {
  target.style.display = 'none'
  const rect = target.getBoundingClientRect()
  if (rect.top < 0) {
    content.scrollIntoView(true)
  }
  trigger.textContent = '詳細情報をもっと見る'
  trigger.classList.remove('mod-icon-minus-o')
  trigger.classList.add('mod-icon-plus-o')
}

function collapseTargetVisible(target: HTMLElement, trigger: HTMLElement) {
  target.style.display = 'block'
  trigger.textContent = '閉じる'
  trigger.classList.remove('mod-icon-plus-o')
  trigger.classList.add('mod-icon-minus-o')
}

export function expandAllToggle() {
  const content = document.querySelectorAll<HTMLElement>('.js-expand-all-content')
  if (content.length === 0) return

  content.forEach((el) => {
    const target = el.querySelector<HTMLElement>('.js-expand-all-target')
    const trigger = el.querySelector<HTMLElement>('.js-expand-all-button')
    if (target === null || trigger === null) return

    expandTargetHidden(target, trigger, el)

    trigger.addEventListener('click', () => {
      if (target.style.display === 'block') {
        expandTargetHidden(target, trigger, el)
      } else {
        collapseTargetVisible(target, trigger)
      }
    })
  })
}
